module.exports = __webpack_public_path__ + "img/sample_order_product1.351c1c57.png";